module.exports = __webpack_public_path__ + "static/media/writing.475ec68f.svg";